import $ from 'jquery';

export default class {
  constructor(el) {
    const _this = this;
    this.dom = {
      el: el,
      form: el,
      container: document.querySelector('[data-loading="post"]'),
      apply: document.querySelector('[data-js="apply"]'),
      loading: document.querySelector('[data-js="posts-loading"]'),
      trigger: document.querySelector('[data-js="posts-trigger"]'),
    }

    this.input = {
      paged: this.dom.el.querySelector('input[name="paged"]'),
      maxpage: this.dom.el.querySelector('input[name="maxpage"]'),
      ppp: this.dom.el.querySelector('input[name="ppp"]'),
    }

    this.maxpage = this.input.maxpage.value;
    this.paged = this.input.paged.value;
    this.ppp = this.input.ppp.value;

    this.formFetchSubmit = this.formFetchSubmit.bind(this);
    this.formSubmit = this.formSubmit.bind(this);

    this.init();
  }

  init() {
    const _this = this;
    this.dom.trigger.addEventListener('click', e => {
      _this.dom.apply.click();
    })
    // this.dom.form.addEventListener('submit', this.formFetchSubmit); // うまく動かない
    this.dom.form.addEventListener('submit', this.formSubmit);
  }

  formFetchSubmit(e) {
    const _this = this;
    e.preventDefault();

    this.dom.loading.dataset.is = 'show';

    //  Creating data 
    let requestData = {
      action: 'ajaxCallback',
      myData: 'Your data',
      ppp: this.ppp,
      paged: this.paged
    };
      
    // Initiating AJAX request 
    fetch(this.dom.el.getAttribute('action'), {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(requestData).toString(),
    })
    .then(res => {
      console.log({res})
      // return res.json(); // if responce is in json.
      return res.text();
    })
    .then(data => {
      console.log({data});
      _this.dom.loading.dataset.is = 'hidden';
      _this.appendElms(data);
      _this.setPaged();
    })
    .catch(err => console.log(err));

  }

  formSubmit(e) {
    const _this = this;
    e.preventDefault();
    
    this.dom.loading.dataset.is = 'show';

    let filter = $(this.dom.el);
    if ( this.jqxhr ) this.jqxhr.abort();
    if ( this.timer ) clearTimeout(this.timer);

    this.jqxhr = $.ajax({
      url: filter.attr('action'),
      data: filter.serialize(), // form data
      type: filter.attr('method'), // POST
    })
    .done( function( res ) {
      // console.log('res', res);
    })
    .fail( function() {
      // console.log('fail');
    })
    .always( function( res ) {
      _this.res = res;
      // console.log({res})
      _this.dom.loading.dataset.is = 'hidden';
      _this.appendElms(res);
      _this.setPaged();
    });
  }

  setPaged() {
    this.paged = Number(this.paged) + 1;
    this.input.paged.value = this.paged;

    if (this.paged >= this.maxpage) {
      this.dom.trigger.dataset.is = 'hidden';
    }
  }

  appendElms(_res) {
    const _this = this;
    [..._this.htmlToNode(_res)].forEach(elms => {
      _this.dom.container.appendChild(elms);
    });
  }

  htmlToNode(htmlStr) {
    if (!htmlStr || typeof htmlStr !== 'string') return;
    let tmpElmt = document.createElement('div'), i = 0, len = 0, nodes = [];
    // 高速処理するが対応ブラウザを考えinnerHTMLを使用
    tmpElmt.innerHTML = htmlStr; // tmpElmt.insertAdjacentHTML('beforeend', htmlStr);
    return tmpElmt.childNodes;
  }
}